module.exports = __webpack_public_path__ + "img/success.057f795b.png";